import { inject } from '@angular/core';
import { Permission } from '../directives/has-permission';
import { OrganizationsStore } from '../store/organizations.store';
import { UserInfoService } from '../../user/services/user-info.service';

export const permissionGuard = (pm: Permission | Permission[]) => () => {
  const userRole = inject(UserInfoService).info()?.role;
  if (userRole === 'USER_ADMIN') {
    return true;
  }

  const orga = inject(OrganizationsStore).selected()?.data;
  if (!orga) {
    return true;
  }
  const permissions = orga.metadata.userPermissions ?? [];
  const acceptedPermissions = Array.isArray(pm) ? pm : [pm];
  if (permissions.length > 0 && acceptedPermissions.some((p) => permissions.includes(p))) {
    return true;
  }
  console.error('Access denied: insufficient permissions to access page', {
    acceptedPermissions,
    permissions,
  });
  return false;
};
